// app/javascript/dashboard/store/modules/whatsappTemplates.js
import types from '../mutation-types';
import WhatsappTemplatesAPI from '../../api/whatsappTemplates';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  selectedTemplate: {},
};

export const getters = {
  getTemplates: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getSelectedTemplate: $state => $state.selectedTemplate,
};

export const actions = {
  async fetch({ commit }, { forceRefresh = false, inboxId = null } = {}) {
    commit(types.SET_WHATSAPP_TEMPLATES_UI_FLAG, { isFetching: true });
    try {
      // Clear existing templates if force refresh (to avoid showing cached templates from other accounts)
      if (forceRefresh) {
        commit(types.SET_WHATSAPP_TEMPLATES, []);
      }
      const response = await WhatsappTemplatesAPI.getAll(inboxId);
      commit(types.SET_WHATSAPP_TEMPLATES, response.data);
    } catch (error) {
      // Handle error
    } finally {
      commit(types.SET_WHATSAPP_TEMPLATES_UI_FLAG, { isFetching: false });
    }
  },

  async fetchSingle({ commit }, templateId) {
    commit(types.SET_WHATSAPP_TEMPLATES_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await WhatsappTemplatesAPI.getSingle(templateId);
      commit(types.SET_WHATSAPP_TEMPLATE_SELECTED, response.data);
      return response.data;
    } catch (error) {
      // Handle error
      return null;
    } finally {
      commit(types.SET_WHATSAPP_TEMPLATES_UI_FLAG, { isFetchingItem: false });
    }
  },

  async create({ commit }, templateData) {
    commit(types.SET_WHATSAPP_TEMPLATES_UI_FLAG, { isCreating: true });
    try {
      const response = await WhatsappTemplatesAPI.createTemplate(templateData);
      commit(types.ADD_WHATSAPP_TEMPLATE, response.data.template);
      return response.data;
    } finally {
      commit(types.SET_WHATSAPP_TEMPLATES_UI_FLAG, { isCreating: false });
    }
  },

  async update({ commit }, { id, data }) {
    commit(types.SET_WHATSAPP_TEMPLATES_UI_FLAG, { isUpdating: true });
    try {
      const response = await WhatsappTemplatesAPI.updateTemplate(id, data);
      commit(types.EDIT_WHATSAPP_TEMPLATE, response.data);
      return response.data;
    } finally {
      commit(types.SET_WHATSAPP_TEMPLATES_UI_FLAG, { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit(types.SET_WHATSAPP_TEMPLATES_UI_FLAG, { isDeleting: true });
    try {
      await WhatsappTemplatesAPI.deleteTemplate(id);
      commit(types.DELETE_WHATSAPP_TEMPLATE, id);
    } finally {
      commit(types.SET_WHATSAPP_TEMPLATES_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_WHATSAPP_TEMPLATES_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.SET_WHATSAPP_TEMPLATES]($state, data) {
    $state.records = data;
  },

  [types.SET_WHATSAPP_TEMPLATE_SELECTED]($state, data) {
    $state.selectedTemplate = data;
  },

  [types.ADD_WHATSAPP_TEMPLATE]($state, data) {
    $state.records.push(data);
  },

  [types.EDIT_WHATSAPP_TEMPLATE]($state, data) {
    $state.records = $state.records.map(record => {
      if (record.id === data.id) {
        return { ...data };
      }
      return record;
    });
    if ($state.selectedTemplate.id === data.id) {
      $state.selectedTemplate = data;
    }
  },

  [types.DELETE_WHATSAPP_TEMPLATE]($state, id) {
    $state.records = $state.records.filter(record => record.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
